import { shape, string } from 'prop-types';

export default shape({
    main: string,
    cdn: string,
    react_assets: string,
});
